import matchesReferralSensitivity from "./matchesReferralSensitivity";
const getServiceTypesSortPriority = option => {
  const {
    disabledCount,
    total
  } = option.children.reduce((acc, child) => {
    if (child.selectionDisabled) acc.disabledCount++;
    acc.total++;
    return acc;
  }, {
    disabledCount: 0,
    total: 0
  });
  if (disabledCount === 0) return 0; // all children enabled
  if (disabledCount === total) return 2; // all children disabled
  return 1; // some enabled, some disabled
};
const getOrderedServices = (services, forwardReferralParams) => {
  return services.map(serviceType => {
    // add selectionDisabled prop to child that does not match with referral sensitive
    const children = [...serviceType.children].map(child => ({
      ...child,
      selectionDisabled: !matchesReferralSensitivity(child, forwardReferralParams)
    }));
    // sort by selectionDisabled at the bottom
    const sortedChildren = children.sort((a, b) => Number(a.selectionDisabled) - Number(b.selectionDisabled));
    return {
      ...serviceType,
      selectionDisabled: !matchesReferralSensitivity(serviceType, forwardReferralParams),
      children: sortedChildren
    };
  }).sort((a, b) => getServiceTypesSortPriority(a) - getServiceTypesSortPriority(b));
};
export default getOrderedServices;
//# sourceMappingURL=getOrderedServices.js.map